import { DocumentData, DocumentReference, QueryDocumentSnapshot } from '@angular/fire/compat/firestore';
import { Timestamp } from '@firebase/firestore-types';

export class Investment {
  id?: string;
  doc?: QueryDocumentSnapshot<DocumentData>;
  created_at?: any;
  updated_at?: any;
  title?: string;
  slug?: string;
  keyword!: string;
  description!: string;
  featured?: boolean;
  hide?: boolean;
  hero_heading?: string;
  hero_subheading?: string;
  hero_graphic?: DocumentReference;
  hero_right_content?: string;
  faq?: Array<{heading: string; content: string}>;
  banner_fact!: string;
  featured_franchise!: string[];
  opportunity_franchise!: string[];
  trending_franchise!: string[];
  featured_image!: string;
  log_type = 'investment';
}
